import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { inject, observer } from "mobx-react";
import * as mobx from 'mobx'
import green from '@material-ui/core/colors/green';
import Card from '@material-ui/core/Card';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Favorite from '@material-ui/icons/Favorite';
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import CampaignSetup from '../../../CampaignSetup';
import { CardHeader } from '@material-ui/core';
import LeadTypes from './LeadTypes';
import Qualifiers from './Qualifiers';

const toolTips = {
  qualifiers:{
    standard:'A standard lead means that the person who submitted for a quote through our form reported direct opt-in interest.',
    split_policy:'Split Policy Leads Coming Soon! \n When the person who submitted for a quote through our form may not qualify but reports interest from a separate party in his or her household, this is referred to as a split policy lead.'
  },
  contactTypes:{
    phone: 'Data lead info that was submitted with a valid, connected phone number.',
    email_only: 'Data lead info that was submitted without a connected phone number but with a valid email address.',
    live_transfer: 'Live transfer leads are delivered with a direct phone connection in real-time.'
  }
}

const styles = theme => ({
  root: {
      marginTop: theme.spacing.unit,
      padding: theme.spacing.unit * 2
  },
  tip:{
    color:'#000000'
  },
  toolTips:{
    color: '#FFFFFF',
    backgroundColor: '#000000',
    border: '1px solid #45A29E',
    //opacity: 1,
  },
  prices:{
    padding: theme.spacing.unit * 2
  },
  title: {
    marginTop: theme.spacing.unit
  },
  divider:{
    marginTop: theme.spacing.unit,
  //  marginLeft: theme.spacing.unit * 2
  },
  checked: {},
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
})

function jsUcfirst(string) 
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}

@inject("commonStore")
@observer
class TieredPricing extends React.Component {
  state = {
    'none': true
  };
  componentDidMount(){
      console.log('componentDidMount')
      const { conditions } = this.props
      const update = {}
      console.log(this.props)
      if(conditions){
        for (const condition of conditions){
          update[condition] = true
        }
      }
      this.setState(update)
  }
  makeLabel = (value) => {
    const splitArray = value.split('_')
    if(splitArray.length > 1){
      return `${jsUcfirst(splitArray[0])} ${jsUcfirst(splitArray[1])}`
    }
    return jsUcfirst(value)
  }
 /* makeLeadTypeOptions = () => {
    const { commonStore, classes, handleTopToggle, leadType: activeLeadType } = this.props
    const { network } = commonStore
    const { types } = network
    const { leadTypes } = types

    return leadTypes.map(key => {
            return (
              <Tooltip className={classes.tip} title={toolTips['leadTypes'][key]}>
              <FormControlLabel
              key={key}
              control={
                <Checkbox
             //     disabled={priceMapType !== 'carte' || campaignID}
                  checked={activeLeadType === key}
                  onChange={() => {handleTopToggle('leadType', key)}}
                  value={key}
                  color="primary"
                />
              }
              label={this.makeLabel(key)}
            />
            </Tooltip>
          )
    })

  }*/

  makeQualifierOptions = () => {
    const { commonStore, classes, handleTopToggle, qualifiers: activeQualifiers } = this.props
    const { network } = commonStore
    const { types } = network
    const { qualifiers } = types

    return qualifiers.map(key => {
            return (
              <Tooltip 
              classes={{
                tooltip: classes.toolTips,
              }}
              key={key} title={toolTips['qualifiers'][key]}>
              <FormControlLabel
              control={
                <Checkbox
                  checked={activeQualifiers.includes(key)}
                  onChange={() => {handleTopToggle('qualifiers', key)}}
                  value={key}
                  color="primary"
                />
              }
              label={this.makeLabel(key)}
            />
            </Tooltip>
          )
    })

  }

  makeContactOptions = () => {
    const { commonStore, classes, handleTopToggle, contactTypes: activeContactTypes } = this.props
    const { network } = commonStore
    const { types } = network
    const { contactTypes } = types
    console.log('contactTypes')
    return contactTypes.map(key => {
            console.log(key)
            let label = key
            if(key === 'phone'){
              label = 'Phone & Email'
            }

            return (
              <Tooltip 
              classes={{
                tooltip: classes.toolTips,
              }}
              key={key} title={toolTips['contactTypes'][key]}>
              <FormControlLabel
              control={
                <Checkbox
             //     disabled={priceMapType !== 'carte' || campaignID}
                  checked={activeContactTypes.includes(key)}
                  onChange={() => {handleTopToggle('contactTypes', key)}}
                  value={key}
                  color="primary"
                />
              }
              label={this.makeLabel(label)}
            />
            </Tooltip>
          )
    })

  }
 
  
  render() {
    const { classes, leadType } = this.props;
///need to auto select the next tab is one is removed
    return (
        <div>
      
        <Typography variant="h5"> {`Select ${this.makeLabel(leadType)} Campaign Filters`}</Typography>
        <div className={classes.root}>
          {/*  <div>
            <Typography variant="subtitle2">Step 1: Select Your Lead Type</Typography>
            {this.makeLeadTypeOptions()}
          </div>*/}
            <div>
            <Typography variant="h5">{`Step 1: Select ${this.makeLabel(leadType)} Lead Sub-Type`}</Typography>
            {this.makeQualifierOptions()}
            </div>
            <div>
            <Typography variant="h5">Step 2: Set Filters for Each Contact Type</Typography>
            {this.makeContactOptions()}
            </div>
            </div>
        </div>
    );
  }
}

TieredPricing.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TieredPricing);


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/Filters/Tiered/LeadOptions.js